import { RichText } from '@mutiny-pkg/champaign-schemas/src/schemas/richText/interfaces';
import { StreamingRichText } from '@mutiny-pkg/champaign-schemas/src/schemas/richText/streaming';
import { hydrateRichTextVariables, normalizeStreamingRichText, renderRichTextToPlainString } from '../../richtext/ast';
import { sanitizeUrl } from '../../utils/url';

/**
 * Resolves a link element's href (RichText, streaming RichText, or plain string) to a
 * final anchor href: hydrates variables, flattens to a string, then normalizes the URL so
 * protocol-less values (e.g. `mutinyhq.com`) get `https://` and don't resolve as relative links.
 * Returns undefined when there is no usable href so callers skip rendering the anchor.
 */
export function resolveHref(
  href: StreamingRichText | RichText | string | undefined | null,
  overrideVariables?: Partial<Record<string, string>>,
  isEditor?: boolean,
): string | undefined {
  if (!href) return undefined;

  let value: RichText | string = normalizeStreamingRichText(href);
  if (typeof value !== 'string') {
    value = hydrateRichTextVariables(value, overrideVariables || {}, isEditor);
  }
  if (typeof value !== 'string') {
    value = renderRichTextToPlainString(value);
  }

  return value ? sanitizeUrl(value) : undefined;
}
